import BaseFormController from "../../../validation/BaseFormController";
import {FormField, OptionalFormField, RequiredFormField} from "../../../validation/FormField";
import Address from "../../../model/address/Address";
import {none, Option} from "ts-option";
import FormValidation from "../../../validation/FormValidation";
import SiteData from "../../../model/site/SiteData";
import MentionUtils from "../../../utils/MentionUtils";
import JobData from "../../../model/job/JobData";

const uuidv4 = require("uuid/v4");

export default class JobForm extends BaseFormController<JobForm> {
	private constructor(formId: string,
		public readonly address: OptionalFormField<Address>,
		public readonly principalContactId: RequiredFormField<string>,
		public readonly description: OptionalFormField<string>,
		public readonly fieldWithFocus: FormField<any>,
		public readonly watchers: OptionalFormField<string[]>,
		public readonly agentId: RequiredFormField<string>) {
		super(fieldWithFocus, formId)
	}

	private static CreateJobForm({
		address = none,
		principalContactId = none,
		description = none,
		watchers = none,
		agentId = none
	}) {
		const addressField = OptionalFormField.create<Address>(address);
		return new JobForm(
			uuidv4(),
			addressField,
			RequiredFormField.create<string>(principalContactId, "Principal Contact is required"),
			OptionalFormField.create<string>(description),
			addressField,
			OptionalFormField.create<string[]>(watchers),
			RequiredFormField.create<string>(agentId, "Agent is required"),
		)
	}

	static createEmpty(agentId: Option<string>): JobForm {
		return JobForm.CreateJobForm({agentId})
	}

	copy({
		formId = this.formId,
		address = this.address,
		principalContactId = this.principalContactId,
		description = this.description,
		fieldWithFocus = this.fieldWithFocus,
		watchers = this.watchers,
		agentId = this.agentId
	}) {
		return new JobForm(formId,
			address,
			principalContactId,
			description,
			fieldWithFocus,
			watchers,
			agentId
		);
	}

	fields(): FormField<any> [] {
		return [this.address, this.principalContactId, this.description];
	}

	onValid(callback: (job: JobData,
		site: Option<SiteData>,
		watchers: string[],
		agentId: Option<string>) => void): void {
		const jobDataValid = FormValidation.validateFields(
			[this.address, this.principalContactId, this.agentId],
			() => {}
		).isValid;
		if (jobDataValid) {
			const principalContact = this.principalContactId.getValue();
			const extendedDescription = this.description.getOptionalValue();
			const desc = extendedDescription.map(dr => MentionUtils.getPlainText(dr, true));
			const siteData = this.address.getOptionalValue().map(address => new SiteData(address));
			const jobData = new JobData(principalContact, desc, extendedDescription, null, none, none, none, null,
				null, none, none, none);
			callback(jobData, siteData, this.watchers.getValue().getOrElse([]), this.agentId.getOptionalValue())
		}
	}
}
